import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import BDNavbar from "@/components/bridgedatum/Navbar";
import BDFooter from "@/components/bridgedatum/Footer";

const BridgeDatumLayout = () => {
  const location = useLocation();
  React.useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [location.pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAFA] text-[#0A192F] font-body">
      <BDNavbar />
      <main className="flex-1 pt-28 sm:pt-32">
        <Outlet />
      </main>
      <BDFooter />
    </div>
  );
};

export default BridgeDatumLayout;
